module.exports = __webpack_public_path__ + "img/i_ar_nxt_ss_b.b1f18afa.svg";